/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, { Component, Fragment } from "react";
import NavBar from "../components/global/NavBar";
import { Grid, CircularProgress, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Redirect } from "react-router-dom";
import DatasetCard from "../components/datasets/DatasetCard";
import { getDatasets, deleteDataset } from "../components/global/API";
import DatasedAdd from "../components/datasets/DatasedAdd";
import CustomizedSnackbars from "../components/global/CustomizedSnackbars";
import StepperSimple from "../components/global/StepperSimple";
import galicia from "../components/images/galicia.png";
import usc from "../components/images/usc.png";
import campusVida from "../components/images/campusvida.png";
import ue from "../components/images/ue.png";
import xunta from "../components/images/xunta.png";
import DatasedAddBeginner from "../components/datasets/DatasedAddBeginner";
import DatasedAddBeginnerScratch from "../components/datasets/DatasedAddBeginnerScratch";
import xacobeo from "../components/images/xacobeo-color-original.jpg";
import citius_horizontal from "../components/images/citius_horizontal.png";

const styles = theme => ({
  root: {
    marginTop: 70,
    marginBottom:100,
    justifyContent: "center",
    justifyItems: "center",
    display: "-webkit-flex",
    webkitFlexWrap: "wrap",
    flexWrap: "wrap"
  },
  progress: {
    margin: "auto",
    marginTop: 40,
    marginBottom: 30
  },
  loader: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    justifyItems: "center"
  },
  footer:{
    boxShadow: "0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
    display:"inline-table",
    justifyContent:"space-evenly",
    position:"fixed",
    bottom:0,
    height:100,
    left:0,
    width:"100%",
    backgroundColor:"white",
  },
  centerFotter:{
    display:"flex",
    justifyContent:"space-evenly",
  },
  leftLogos: {
    height: 36,
    marginTop: 20,
    marginBottom: 20
  },
  rightLogos: {
    height: 60,
    marginTop: 20,
    marginBottom: 20
  },
});

class Datasets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datasetNewName:"example",
      error: false,
      loading: true,
      datasets: []
    };
    this.deleteDataset = this.deleteDataset.bind(this);
    this.handleDatasetClick = this.handleDatasetClick.bind(this);
    this.changeFile = this.changeFile.bind(this);
    this.changeFileScratch = this.changeFileScratch.bind(this);
    this.handleDatasetNewName = this.handleDatasetNewName.bind(this);
    this.handleDatasetNewScratch = this.handleDatasetNewScratch.bind(this);
  }

  async getDatasets() {
    const response = await getDatasets(this.props.token);

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
          "error",
          this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({ redirect: true });
      } else {
        this.setState({
          error: response.error,
          message: response.data,
          loading: false
        });
      }
    } else {
      this.setState({
        datasets: response.data,
        loading: false
      });
    }
  }

  async deleteDataset(name) {
    this.setState({
      loading: true
    });
    const response = await deleteDataset(name, this.props.token);
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
          "error",
          this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({ redirect: true });
      } else {
        this.setState({
          error: response.error,
          message: response.data,
          loading: false
        });
      }
    } else {
      this.getDatasets();
      this.props.handleGlobalMessage(
        "success",
        "Dataset " + name + this.props.language.labels[this.props.language.id].succesfullyDeleted
      );
      this.setState({
        loading: false
      });
    }
  }
  changeFile(file) {
    this.setState({
      file: file
    });
  }
  changeFileScratch(file) {
    this.setState({
      fileScratch: file
    });
  }
  async componentDidMount() {
    this.getDatasets();
  }
  handleDatasetClick(dataset,checked){
    if(checked===true) {
      this.setState({checkedDataset:dataset})
    }else{
      this.setState({checkedDataset:""})
    }
  }
  handleDatasetNewName(datasetNewName){
    console.log(datasetNewName)
      this.setState({datasetNewName:datasetNewName})
  }
  handleDatasetNewScratch(datasetNewName){
    console.log(datasetNewName)
    this.setState({datasetNewName:datasetNewName})
  }

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({
      error: false
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <Fragment>
        <NavBar
          language={this.props.language}
          handleLanguageChange={this.props.handleLanguageChange}
        />
        <Grid container justify="center">
          <Grid item xs={12} className={classes.root}>
            {this.state.loading ? (
              <div className={classes.loader}>
                <CircularProgress className={classes.progress} size={100} />
                <Typography variant="h3" align="center">
                  {this.props.language.labels[this.props.language.id].loading}
                </Typography>
              </div>
            ) : (
              <Fragment>
                {this.props.mode === "beginner" &&
                    <StepperSimple
                        language={this.props.language}
                        initialValue={0}
                        dataset={this.state.checkedDataset}
                        nameNewDataset={this.state.datasetNewName}
                        nameNewDatasetScratch={this.state.datasetNewNameScratch}
                        file={this.state.file}
                        fileScratch={this.state.fileScratch}
                        handleDataset={this.props.handleDataset}
                        handleGlobalMessage={this.props.handleGlobalMessage}
                        handleDatasetNewNameBeginner={this.props.handleDatasetNewNameBeginner}
                        handleDatasetNewNameScratch={this.props.handleDatasetNewNameScratch}
                    />
                }
                {this.props.mode ==="expert" &&
                  <DatasedAdd language={this.props.language}/>
                }
                {this.props.mode ==="beginner" &&
                    <Fragment>
                      <DatasedAddBeginner
                          changeFile={this.changeFile}
                          handleDatasetClick = {this.handleDatasetClick}
                          handleDatasetNewName = {this.handleDatasetNewName}
                          language={this.props.language}
                          dataset={"new"}
                          checked={"new" === this.state.checkedDataset}
                      />
                      <DatasedAddBeginnerScratch
                        changeFile={this.changeFileScratch}
                        handleDatasetClick = {this.handleDatasetClick}
                        handleDatasetNewScratch = {this.handleDatasetNewScratch}
                        language={this.props.language}
                        dataset={"newScratch"}
                        checked={"newScratch" === this.state.checkedDataset}
                      />
                    </Fragment>
                }
                {this.state.datasets.map(dataset => {
                  return (
                    <DatasetCard
                      mode={this.props.mode}
                      handleDatasetClick = {this.handleDatasetClick}
                      checked={dataset === this.state.checkedDataset}
                      key={dataset.name}
                      language={this.props.language}
                      handleDataset={this.props.handleDataset}
                      dataset={dataset}
                      deleteDataset={this.deleteDataset}
                      goToBuilder = {this.props.goToBuilder}
                      classifierDontExist={this.props.classifierDontExist}
                    />
                  );
                })}
              </Fragment>
            )}
          </Grid>
        </Grid>
        <footer className={classes.footer}>
          <Grid container direction="row" alignItems="center" justify={"center"}>
            <Grid  className={classes.centerFotter} item xs={12} md={8} lg={8} >
              <img
                  src={galicia}
                  alt="logo turístico galicia"
                  className={classes.leftLogos}
              />
              <img
                  src={xacobeo}
                  alt="logo xacobeo 2021"
                  className={classes.leftLogos}
              />
              <img src={citius_horizontal} alt="logo citius" className={classes.leftLogos} />
              <img src={usc} alt="logo usc" className={classes.leftLogos} />
              <img
                  src={campusVida}
                  alt="logo campus vida"
                  className={classes.leftLogos}
              />
            </Grid>
            <Grid className={classes.centerFotter}  item xs={12} md={4} lg={4} >
              <img
                  src={ue}
                  alt="logo unión europea"
                  className={classes.rightLogos}
              />
              <img
                  src={xunta}
                  alt="logo xunta de galicia"
                  className={classes.rightLogos}
              />
            </Grid>
          </Grid>
          <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "center"}}>
            {this.props.language.labels[this.props.language.id].fondoEuropeo}
          </Typography>
        </footer>
        <CustomizedSnackbars
          openFail={this.state.error}
          handleClose={this.handleClose}
          message={this.state.message}
        />
        {!this.props.token || (this.state.redirect && this.props.mode==="expert")? <Redirect to="/" /> : ""}
      </Fragment>
    );
  }
}

Datasets.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Datasets);
